module.exports = __webpack_public_path__ + "img/PDF.c68d4e0c.png";